var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23857 1.2523L0.518046 8.97297C0.33964 9.15137 0.241699 9.38925 0.241699 9.6484C0.241699 9.90234 0.33964 10.1404 0.518046 10.3185L8.23124 18.032C8.40979 18.2104 8.64781 18.3086 8.90175 18.3086C9.15569 18.3086 9.39385 18.2105 9.57225 18.032L10.1403 17.4639C10.3187 17.2855 10.4172 17.0473 10.4172 16.7934C10.4172 16.5395 10.3187 16.3014 10.1403 16.1229L3.66313 9.64573L10.1478 3.16136C10.326 2.98296 10.4244 2.74494 10.4244 2.49086C10.4244 2.23692 10.326 1.99904 10.1478 1.8205L9.57944 1.2523C9.2098 0.882805 8.60821 0.882805 8.23857 1.2523Z",
    fill: "#A93E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkArrowLeft);
export default __webpack_public_path__ + "static/media/pink-arrow-left.586b240400d67786b3ff6877acedc103.svg";
export { ForwardRef as ReactComponent };